import axios from 'axios';

// Use environment variable or fallback based on current hostname
const getApiUrl = () => {
  // If REACT_APP_API_URL is set, use it
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // Otherwise, determine based on current hostname
  const hostname = window.location.hostname;
  
  // Production domains
  if (hostname === 'drinks.kanchinnotech.nl' || hostname === 'www.drinks.kanchinnotech.nl') {
    return 'https://www.pythondrinks.kanchinnotech.nl/api';
  }
  
  // Local development
  return 'http://localhost:5000/api';
};

const API_URL = getApiUrl();

console.log('API_URL:', API_URL); // This will help debug

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // If error is 401 and not already retrying
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const refreshToken = localStorage.getItem('refresh_token');
        const response = await axios.post(`${API_URL}/auth/refresh`, {
          refresh_token: refreshToken,
        }, {
          headers: {
            'Content-Type': 'application/json',
          }
        });

        if (response.data.access_token) {
          localStorage.setItem('access_token', response.data.access_token);
          originalRequest.headers.Authorization = `Bearer ${response.data.access_token}`;
          return api(originalRequest);
        }
      } catch (refreshError) {
        // Refresh failed, redirect to login
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        // Use window.location.href for redirect
        window.location.href = '/auth/login';
      }
    }

    return Promise.reject(error);
  }
);

export default api;